import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import Bolt from '@nationwide-bolt/bundle-core';
import { AppModule } from './app/app.module';


Bolt.initialize().then(() => {
  platformBrowserDynamic()
    .bootstrapModule(AppModule)
    .catch((err) => console.log(err));
});

